<template>
  <app-image
    v-if="plain"
    class="app-empty-state__image"
    :src="emptyImage"
    alt=""
  />
  <van-empty
    v-else
    class="app-empty-state"
    :image="emptyImage"
    :description="description"
  >
    <slot />
  </van-empty>
</template>

<script setup>
import emptyImage from "@/assets/images/empty.png";

defineProps({
  description: {
    type: String,
    default: "",
  },
  plain: {
    type: Boolean,
    default: false,
  },
});
</script>

<style scoped lang="scss">
.app-empty-state {
  --van-empty-image-size: 120px;

  :deep(.van-empty__image img) {
    object-fit: contain;
  }
}

.app-empty-state__image {
  display: block;
  width: 120px;
  height: 120px;
  object-fit: contain;
}
</style>
